<template>
  <div>
    <el-dialog top="5vh"
               title="查看或更新签约信息"
               :visible.sync="dialogFormVisible"
               @close="handleToClose"
               :close-on-click-modal="false"
               width="700px">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               :rules="rules"
               label-width="110px"
               size="small">
        <el-form-item label="姓名 ："
                      prop="realname">
          <el-input v-model="dataForm.realname"
                    placeholder="请输入姓名"
                    style="width: 100%;"></el-input>
        </el-form-item>
        <el-form-item label="手机号："
                      prop="mobile">
          <el-input v-model="dataForm.mobile"
                    placeholder="请输入手机号"
                    style="width:100%;"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                    disabled>
          </el-input>
        </el-form-item>
        <el-form-item label="微信号："
                      prop="wechat">
          <el-input v-model="dataForm.wechat"
                    placeholder="请输入微信号"
                    style="width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="微信名："
                      prop="wechat_nickname">
          <el-input v-model="dataForm.wechat_nickname"
                    placeholder="请输入微信号"
                    style="width:100%;">
          </el-input>
        </el-form-item>

        <el-form-item label="性别："
                      prop="gender">
          <el-radio-group v-model="dataForm.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
            <el-radio :label="0">未知</el-radio>
          </el-radio-group>
          <el-checkbox @change="(...event) =>{handleToParams(event, 'gender')}"></el-checkbox>
        </el-form-item>
        <el-form-item label="QQ号："
                      prop="name">
          <el-input v-model="dataForm.qq"
                    placeholder="请输入QQ号"
                    style="width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证号："
                      prop="id_card_no">
          <el-input v-model="dataForm.id_card_no"
                    placeholder="请输入身份证号"
                    style="width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="结算周期："
                      prop="settle_cycle_type">
          <el-radio-group v-model="dataForm.settle_cycle_type">
            <el-radio :label="2">周结</el-radio>
            <el-radio :label="1">月结</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签约课时费："
                      prop="fee_amount">
          <el-input v-model="dataForm.fee_amount"
                    placeholder="请输入签约课时费"
                    oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元/小时</template>
          </el-input>
          <div class="gray">
            其中包含：
            <div style="display:flex;justify-content: space-between;width:80%">
              <div style="position: relative;width:45%">
                <el-input v-model="dataForm.salary_profit_fix_amount"
                          style="marginRight:10px"
                          placeholder=""
                          oninput="value=value.replace(/[^0-9.]/g,'')"
                          @blur="basInput">

                  <template slot="prepend">基础课时费</template>
                </el-input>
                <span style=" position: absolute;top:1px;right:2px;fontSize:12px;">元/小时</span>
              </div>
              <div style="position: relative;width:45%">
                <el-input v-model="dataForm.bonus_profit_fix_amount"
                          style="marginRight:10px"
                          placeholder=""
                          @blur="signInput"
                          oninput="value=value.replace(/[^0-9.]/g,'')">
                  <template slot="prepend">结课奖励</template>
                </el-input>
                <span style=" position: absolute;top:1px;right:2px;fontSize:12px;">元/小时</span>
              </div>

            </div>

          </div>
        </el-form-item>
        <el-form-item label="备注："
                      prop="contract_remark">
          <el-input v-model="dataForm.contract_remark"
                    placeholder="请输入备注"
                    style="width:100%;"
                    type="textarea">
          </el-input>
        </el-form-item>
        <el-form-item label="成绩证明："
                      prop="recruit_score_img">
          <div style="display: flex;">
            <el-upload class="avatar-uploader"
                       :action="imgUploadUrl"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess">
              <img v-if="imageUrl"
                   :src="imageUrl"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="签约状态："
                      prop="contract_status">
          <el-radio-group v-model="dataForm.contract_status">
            <el-radio :label="0">未签约</el-radio>
            <el-radio :label="1">已签约</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签约日期："
                      prop="contract_start_time">
          <el-date-picker v-model="dataForm.contract_start_time"
                          type="date"
                          placeholder="选择日期"
                          value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="延后同步："
                      prop="status">
          <el-switch v-model="share_delay_sync_on_off_status"
                     :active-value="1"
                     :inactive-value="0"
                     :disabled="disabled">
          </el-switch>
          <span v-if="share_delay_sync_on_off_status==0"
                style="marginLeft:10px">(保存后将立即同步共享)</span>
          <span v-if="share_delay_sync_on_off_status==1"
                style="marginLeft:10px">(将延时3个月后自动同步)</span>
          <span v-if="share_delay_sync_on_off_status==2"
                style="marginLeft:10px">(已同步不可操作)</span>
        </el-form-item>

        <el-form-item label="签约时长："
                      prop="recruit_type">
          <div class="count-wrap">
            <div class="count-item"
                 @click="chooseCount(1)"
                 :class="{ 'choose': count == 1 }">1年</div>
            <div class="count-item"
                 @click="chooseCount(2)"
                 :class="{ 'choose': count == 2 }">2年</div>
            <div class="count-item"
                 @click="chooseCount(3)"
                 :class="{ 'choose': count == 3 }">3年</div>
          </div>

        </el-form-item>

      </el-form>
      <div class="footer">
        <el-button @click="handleToClose()">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  teacherEdit,
  teacherOne,
  taRecordCreate,
  shareDelaySyncOnOffStatus,
} from '@/request/api'
import { imgUploadUrl } from '@/request/http'
import { log } from 'mathjs'
import { adminUrl, crmUrl } from '@/utils/helper.js'

export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      disabled: false,
      share_delay_sync_on_off_status: 0,
      dialogFormVisible: this.isVisible,
      dataForm: {},
      rules: {
        realname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: '请输入正确的手机号',
          },
        ],
        wechat: [{ required: true, message: '请输入微信号', trigger: 'blur' }],
        fee_amount: [
          { required: true, message: '请输入签约课时费', trigger: 'blur' },
        ],
        settle_cycle_type: [
          { required: true, message: '请选择结算周期', trigger: 'blur' },
        ],
      },
      count: 1,
      imgUploadUrl: imgUploadUrl(),
      imageUrl: '',
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val

      if (val) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    // 基础课时费当输入框里面数值发生改变时
    basInput(e) {
      console.log('e', this.dataForm.salary_profit_fix_amount)
      this.dataForm.bonus_profit_fix_amount =
        Math.round(
          (this.dataForm.fee_amount * 1 -
            this.dataForm.salary_profit_fix_amount * 1) *
            100
        ) / 100
    },
    signInput(e) {
      this.dataForm.salary_profit_fix_amount =
        Math.round(
          (this.dataForm.fee_amount * 1 -
            this.dataForm.bonus_profit_fix_amount * 1) *
            100
        ) / 100
    },
    fetchDetail() {
      teacherOne({ id: this.id }).then((response) => {
        let res = response.data
        this.dataForm = res.data
        console.log(
          'this.share_delay_sync_on_off_status',
          this.dataForm.share_delay_sync_on_off_status
        )
        this.share_delay_sync_on_off_status =
          this.dataForm.share_delay_sync_on_off_status
        if (this.dataForm.share_delay_sync_on_off_status == 2) {
          this.disabled = true
        }

        this.$set(
          this.dataForm,
          'fee_amount',
          res.data.fee_amount ? res.data.fee_amount : null
        )
        this.$set(
          this.dataForm,
          'contract_start_time',
          this.dataForm.contract_start_time
            ? this.dataForm.contract_start_time
            : new Date().getTime()
        )
        if (this.dataForm.recruit_score_img) {
          this.imageUrl = this.dataForm.recruit_score_img
        }
        if (
          this.dataForm.contract_start_time &&
          this.dataForm.contract_end_time
        ) {
          let timestamp =
            Number(this.dataForm.contract_end_time) -
            Number(this.dataForm.contract_start_time)
          this.count = parseInt(timestamp / 31536000000)
        }
      })
    },

    handleToClose() {
      this.$emit('close')
      this.dataForm = {}
      this.disabled = false
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let data = {
            id: this.dataForm.id,
            realname: this.dataForm.realname,
            mobile: this.dataForm.mobile,
            wechat: this.dataForm.wechat,
            id_card_no: this.dataForm.id_card_no,
            qq: this.dataForm.qq,
            contract_start_time: this.dataForm.contract_start_time,
            contract_end_time: this.formateEndTime(),
            contract_status: this.dataForm.contract_status,
            fee_amount: this.dataForm.fee_amount,
            recruit_score_img: this.imageUrl,
            contract_remark: this.dataForm.contract_remark,
            settle_cycle_type: this.dataForm.settle_cycle_type,
            salary_split_type: 2,
            salary_profit_fix_amount: this.dataForm.salary_profit_fix_amount,
            bonus_profit_fix_amount: this.dataForm.bonus_profit_fix_amount,
            wechat_nickname: this.dataForm.wechat_nickname,
            gender: this.dataForm.gender,
          }
          teacherEdit(data).then((response) => {
            let res = response.data
            if (res.code == 0) {
              if (this.dataForm.contract_status == 1) {
                taRecordCreate({
                  record: `已成功签约${this.dataForm.realname}老师`,
                  teacher_id: this.dataForm.id,
                  type: 19,
                }).then((res) => {})
              }
              let parmas = {
                teacher_id: this.dataForm.id,
                share_delay_sync_on_off_status:
                  this.share_delay_sync_on_off_status,
              }
              shareDelaySyncOnOffStatus(parmas).then((res) => {})

              this.$emit('submit')
              this.openStatus = 0
              setTimeout(() => {
                this.handleToClose()
              }, 1100)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    chooseCount(num) {
      this.count = num
    },
    formateEndTime() {
      let num = Number(this.dataForm.contract_start_time)
      return num + 31536000000 * this.count
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = file.response.data.url
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .el-input-group__append {
    background: #f5f5f5 !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 140px;
    height: 140px;
    line-height: 140px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    text-align: center;
  }

  .avatar {
    width: 140px;
    height: 140px;
  }
  .gray {
    padding-left: 10px;
    padding-top: 5px;
    margin-top: 5px;
    height: 100px;
    background: #f7f9fc;
  }

  .count-wrap {
    display: flex;

    align-items: center;

    .count-item {
      padding: 0px 18px;
      font-size: 14px;
      font-family: PingFangSC-Regular-, PingFangSC-Regular;
      color: rgba(0, 0, 0, 0.6);
      border: 1px solid #dcdcdc;
      margin-right: 12px;
      cursor: pointer;

      /deep/.el-input__inner {
        border: none;
        background: transparent;
      }
    }

    .choose {
      background-image: url('https://upload.kaoyanbox.net/c2d67a5112245e425cc58a547522aaa8.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>